import React from 'react';
import { Alert, AlertDescription } from '../../components/ui/alert';
import { AlertCircle, CheckCircle2, Loader2, Trophy, Target, ShoppingCart, Crown, Swords, Briefcase, Gift, Smartphone } from 'lucide-react';
import { Button } from '../../components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../../components/ui/card';
import { Input } from '../../components/ui/input';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const resolveAdUrl = (u) => (u && u.startsWith('/') ? `${BACKEND_URL}${u}` : u);

const PaymentAdMedia = ({ ad }) => (
  ad.media_type === 'video' ? (
    <video
      src={resolveAdUrl(ad.image_url)}
      autoPlay
      loop
      muted
      playsInline
      className="w-full rounded-lg border-2 border-green-300 shadow-lg"
      data-testid="payment-confirmation-ad-video"
    />
  ) : (
    <img
      src={resolveAdUrl(ad.image_url)}
      alt="Anúncio"
      className="w-full rounded-lg border-2 border-green-300 shadow-lg"
      data-testid="payment-confirmation-ad-image"
    />
  )
);

const OrderPaymentView = ({
  creatingOrder,
  handleReset,
  hostEventConfig,
  order,
  orderStatus,
  paymentConfirmationAd,
  timeRemaining,
  userInfo,
}) => {
  return (

          <Card data-testid="qr-code-card" className="max-w-2xl mx-auto">
            {/* Header só aparece quando PENDENTE */}
            {(order.status === 'pending' || orderStatus !== 'completed') && (
              <CardHeader>
                <CardTitle className="text-center text-2xl">
                  {order.payment_method === 'mbway' ? 'Pagamento MB WAY' : 'Pagamento PIX'}
                </CardTitle>
                <CardDescription className="text-center space-y-1">
                  <div>
                    {order.payment_method === 'mbway'
                      ? 'Confirme o pagamento no seu app MB WAY'
                      : 'Escaneie o QR Code ou copie o código PIX'}
                  </div>
                  <div className="text-xs font-mono bg-gray-100 inline-block px-3 py-1 rounded mt-2" data-testid="order-code">
                    Código do Pedido: #{order.id.slice(0, 8).toUpperCase()}
                  </div>
                </CardDescription>
              </CardHeader>
            )}
            <CardContent className="space-y-6">
              {console.log('📺 Renderizando CardContent. order.status:', order?.status, 'orderStatus:', orderStatus, 'creatingOrder:', creatingOrder)}
              
              {/* TELA DE CONFIRMAÇÃO */}
              {!creatingOrder && (order.status === 'completed' || orderStatus === 'completed') && (
                <div className="space-y-4">
                  {/* 1. ANÚNCIO */}
                  {paymentConfirmationAd && paymentConfirmationAd.active && paymentConfirmationAd.image_url && (
                    <div>
                      {paymentConfirmationAd.link_url ? (
                        <a 
                          href={paymentConfirmationAd.link_url} 
                          target="_blank" 
                          rel="noopener noreferrer"
                          className="block hover:opacity-90 transition-opacity cursor-pointer"
                          data-testid="payment-confirmation-ad-link"
                        >
                          <PaymentAdMedia ad={paymentConfirmationAd} />
                        </a>
                      ) : (
                        <PaymentAdMedia ad={paymentConfirmationAd} />
                      )}
                    </div>
                  )}
                  
                  {/* 2. CARD "Transação Concluída" */}
                  <div className="bg-white border-2 border-green-400 rounded-lg p-6 shadow-xl">
                    <div className="text-center">
                      <div className="flex items-center justify-center gap-2 mb-2">
                        <div className="w-16 h-16 rounded-full bg-gradient-to-br from-green-400 to-emerald-500 flex items-center justify-center">
                          <span className="text-4xl">🎉</span>
                        </div>
                      </div>
                      <p className="text-sm text-gray-600 mb-2">Transação Concluída</p>
                      
                      <div className="flex items-center justify-center gap-2">
                        <p className="text-5xl font-black text-transparent bg-clip-text bg-gradient-to-r from-green-500 to-emerald-600">
                          {order.coins.toLocaleString()}
                        </p>
                        <span className="text-5xl">🪙</span>
                      </div>
                      <p className="text-base text-green-600 font-semibold mt-2">moedas creditadas</p>
                      
                      {/* AVISO DE VOTOS GANHOS - Meu Host (Abaixo de moedas creditadas) */}
                      {hostEventConfig?.count_orders_for_votes && order.coins && (
                        <div className="mt-4 p-3 bg-gradient-to-r from-pink-50 to-purple-50 border border-pink-300 rounded-lg">
                          <p className="text-center text-sm font-semibold text-pink-700">
                            🎉 +{Math.floor(order.coins / 10000)} voto(s) para MEU HOST PREFERIDO!
                          </p>
                          <p className="text-center text-xs text-purple-600 mt-1">
                            ⚡ Vote agora mesmo! ⚡
                          </p>
                        </div>
                      )}
                      
                      {console.log('🎰 Verificando ticket. order.mega_prize_ticket:', order.mega_prize_ticket, 'Order completo:', order)}
                      
                      {/* MEGA PRÊMIO - Ticket Gerado */}
                      {order.mega_prize_ticket && (
                        <div className="mt-6 p-4 bg-gradient-to-r from-yellow-100 to-orange-100 border-2 border-yellow-400 rounded-lg">
                          <p className="text-sm font-bold text-yellow-800 mb-2">🎰 MEGA PRÊMIO - SEU TICKET DA SORTE!</p>
                          <div className="flex justify-center gap-2">
                            {order.mega_prize_ticket.split('-').map((num, idx) => (
                              <div key={idx} className="w-10 h-10 rounded-full bg-yellow-500 text-white font-bold flex items-center justify-center text-lg shadow-lg">
                                {num}
                              </div>
                            ))}
                          </div>
                          <p className="text-xs text-yellow-700 mt-2">Você ganhou 6 dezenas da sorte para o MEGA PRÊMIO ACUMULADO! BOA SORTE!</p>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}

              {/* Alerta aguardando pagamento com cronômetro */}
              {order.status === 'pending' && orderStatus !== 'completed' && (
                <div className="space-y-2">
                  <Alert className="bg-blue-50 border-blue-200">
                    <AlertCircle className="h-4 w-4 text-blue-600" />
                    <AlertDescription className="text-blue-800">
                      Aguardando pagamento... Assim que você pagar, as moedas serão creditadas automaticamente!
                    </AlertDescription>
                  </Alert>
                  
                  {/* Cronômetro */}
                  <div className="bg-orange-50 border-2 border-orange-200 rounded-lg p-4 text-center">
                    <p className="text-sm text-gray-600 mb-2">Tempo restante para pagamento:</p>
                    <div className="text-4xl font-bold text-orange-600" data-testid="payment-timer">
                      {Math.floor(timeRemaining / 60)}:{String(timeRemaining % 60).padStart(2, '0')}
                    </div>
                    <p className="text-xs text-gray-500 mt-1">
                      {timeRemaining === 0 ? 'Tempo esgotado! Este QR Code foi cancelado.' : 'Realize o pagamento antes que o tempo expire'}
                    </p>
                  </div>
                </div>
              )}

              {/* QR Code - só mostra se pendente */}
              {(order.status === 'pending' && orderStatus !== 'completed' && timeRemaining > 0) && (
                <>
                  {/* Header PIX */}
                  {order.payment_method === 'pix' && (
                    <div className="bg-gradient-to-r from-cyan-50 to-blue-50 border-2 border-cyan-400 rounded-lg p-4 text-center mb-4">
                      <img 
                        src="https://customer-assets.emergentagent.com/job_2cfdfe5d-5b87-4072-8829-ddaedcfedb94/artifacts/c9vo4jy4_IMG_9401.PNG" 
                        alt="PIX"
                        className="w-16 h-16 mx-auto object-contain"
                      />
                      <p className="text-xl font-bold text-cyan-800 mt-2">Pagamento PIX</p>
                      <p className="text-sm text-cyan-600 mt-1">
                        Valor: <span className="font-bold">R$ {order.amount?.toFixed(2)}</span>
                      </p>
                    </div>
                  )}
                  
                  {order.qrcode_image ? (
                    <div className="flex justify-center">
                      <img
                        src={`data:image/png;base64,${order.qrcode_image}`}
                        alt="QR Code PIX"
                        className="w-64 h-64 border-4 border-purple-500 rounded-lg"
                      />
                    </div>
                  ) : order.pix_copy_paste ? (
                    <div className="flex justify-center">
                      <div className="p-4 bg-white border-4 border-cyan-500 rounded-lg">
                        <img
                          src={`https://api.qrserver.com/v1/create-qr-code/?size=256x256&data=${encodeURIComponent(order.pix_copy_paste)}`}
                          alt="QR Code PIX"
                          className="w-64 h-64"
                        />
                      </div>
                    </div>
                  ) : null}

                  {order.pix_copy_paste && (
                    <div className="space-y-2">
                      <p className="text-sm font-medium">Código PIX Copia e Cola:</p>
                      <div className="flex gap-2">
                        <Input
                          data-testid="pix-code-input"
                          value={order.pix_copy_paste}
                          readOnly
                          className="font-mono text-xs"
                        />
                        <Button
                          data-testid="copy-pix-button"
                          onClick={() => {
                            navigator.clipboard?.writeText(order.pix_copy_paste)?.catch(() => {});
                            alert('Código copiado!');
                          }}
                        >
                          Copiar
                        </Button>
                      </div>
                    </div>
                  )}
                  
                  {/* MB WAY Payment Info */}
                  {order.payment_method === 'mbway' && (
                    <div className="space-y-3">
                      {/* Valor principal */}
                      <div className="bg-white border-2 border-red-200 rounded-xl p-5 text-center shadow-sm">
                        <img src="/mbway-logo.png?v=2" alt="MB WAY" className="w-32 h-auto mx-auto mb-3" />
                        <p className="text-gray-500 text-xs uppercase tracking-wider mb-1">Valor a pagar via MB WAY</p>
                        <p className="text-4xl font-black text-gray-900 tracking-tight">
                          &euro;{order.mbway_amount_eur?.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                        </p>
                        {order.mbway_stripe_fee_eur > 0 && (
                          <p className="mt-1 text-xs text-gray-500" data-testid="mbway-fee-line">
                            inclui &euro;{order.mbway_stripe_fee_eur.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} de taxa MB WAY
                          </p>
                        )}
                        <div className="mt-3 inline-flex items-center gap-2 bg-gray-100 rounded-full px-3 py-1">
                          <span className="text-gray-600 text-xs">R$ {order.amount?.toFixed(2)}</span>
                          <span className="text-gray-300">|</span>
                          <span className="text-gray-600 text-xs">1 EUR = {order.mbway_vet?.toFixed(2)} BRL</span>
                        </div>
                      </div>
                      
                      {/* Status aguardando */}
                      <div className="flex items-center gap-3 bg-amber-50 border border-amber-200 rounded-lg p-3">
                        <div className="w-8 h-8 bg-amber-100 rounded-full flex items-center justify-center flex-shrink-0">
                          <Smartphone className="w-4 h-4 text-amber-600" />
                        </div>
                        <div>
                          <p className="text-sm font-semibold text-amber-800">Aguardando confirmação</p>
                          <p className="text-xs text-amber-600">Verifique a notificação no seu app MB WAY</p>
                        </div>
                      </div>
                      
                      {/* Passos */}
                      <div className="bg-white border border-gray-100 rounded-lg p-4">
                        <div className="space-y-3">
                          <div className="flex items-center gap-3">
                            <div className="w-6 h-6 bg-[#1a1a2e] text-white rounded-full flex items-center justify-center text-xs font-bold flex-shrink-0">1</div>
                            <p className="text-sm text-gray-700">Abra o <strong>app MB WAY</strong> no celular</p>
                          </div>
                          <div className="flex items-center gap-3">
                            <div className="w-6 h-6 bg-[#1a1a2e] text-white rounded-full flex items-center justify-center text-xs font-bold flex-shrink-0">2</div>
                            <p className="text-sm text-gray-700">Toque na <strong>notificação de pagamento</strong></p>
                          </div>
                          <div className="flex items-center gap-3">
                            <div className="w-6 h-6 bg-[#1a1a2e] text-white rounded-full flex items-center justify-center text-xs font-bold flex-shrink-0">3</div>
                            <p className="text-sm text-gray-700">Confirme com <strong>PIN ou biometria</strong></p>
                          </div>
                        </div>
                      </div>
                      
                      {/* Rodapé */}
                      <p className="text-center text-xs text-gray-400">
                        Pagamento instantâneo - Moedas creditadas automaticamente
                      </p>
                    </div>
                  )}
                </>
              )}

              <div className="bg-gray-50 p-4 rounded-lg space-y-2">
                {/* Dados do Usuário */}
                <div className="bg-purple-50 border border-purple-200 rounded p-3 mb-3">
                  <div className="flex items-center gap-3 mb-2">
                    {userInfo?.avatar && (
                      <img 
                        src={userInfo.avatar} 
                        alt={userInfo.nickname}
                        className="w-10 h-10 rounded-full border-2 border-purple-300"
                      />
                    )}
                    <div>
                      <div className="font-bold text-purple-900">{userInfo?.nickname || order.kako_nickname}</div>
                      <div className="text-xs text-purple-600">KAKO ID: {order.kako_id}</div>
                    </div>
                  </div>
                  <div className="text-xs text-gray-700 space-y-1">
                    <div>📄 CPF: <span className="font-mono">{order.customer_cpf?.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')}</span></div>
                    <div>👤 Nome: <span className="font-semibold">{order.customer_name}</span></div>
                  </div>
                </div>

                <div className="flex justify-between border-b pb-2 mb-2">
                  <span className="text-sm text-gray-600">Código do Pedido:</span>
                  <span className="font-mono font-bold text-purple-600" data-testid="order-id-display">
                    #{order.id.slice(0, 8).toUpperCase()}
                  </span>
                </div>
                <div className="flex justify-between">
                  <span className="text-sm text-gray-600">Data e Hora:</span>
                  <span className="font-medium text-gray-800">
                    {new Date(order.created_at).toLocaleString('pt-BR', {
                      day: '2-digit',
                      month: '2-digit',
                      year: 'numeric',
                      hour: '2-digit',
                      minute: '2-digit'
                    })}
                  </span>
                </div>
                <div className="flex justify-between">
                  <span>Pacote:</span>
                  <span className="font-bold">{order.package_name}</span>
                </div>
                <div className="flex justify-between">
                  <span>Moedas:</span>
                  <span className="font-bold text-purple-600">{order.coins}</span>
                </div>
                <div className="flex justify-between text-lg">
                  <span>Total:</span>
                  <span className="font-bold text-orange-600">R$ {order.amount.toFixed(2)}</span>
                </div>
                
                {(order.status === 'completed' || orderStatus === 'completed') && order.completed_at && (
                  <div className="flex justify-between border-t pt-2 mt-2">
                    <span className="text-sm text-green-600">✅ Pago em:</span>
                    <span className="font-medium text-green-600">
                      {new Date(order.completed_at).toLocaleString('pt-BR', {
                        day: '2-digit',
                        month: '2-digit',
                        year: 'numeric',
                        hour: '2-digit',
                        minute: '2-digit'
                      })}
                    </span>
                  </div>
                )}
              </div>

              <Button
                data-testid="new-purchase-button"
                onClick={handleReset}
                variant="outline"
                className="w-full"
              >
                Fazer Nova Compra
              </Button>
            </CardContent>
          </Card>
  );
};

export default OrderPaymentView;
